<template>
  <div>
  </div>
</template>

<script>
export default {
  name: 'bottom'
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/layout/Footer/bottom.vue